import React, { useState, useEffect, useRef } from 'react';

const Accordion = (props) => {
  const { data } = props;
  const [active, setActive] = useState(1);

  let contentRef = [];

  useEffect(() => {
    setHeight();
  });

  const setHeight = () => {
    if (contentRef.length > 0) {
      for (let i = 0; i < contentRef.length; i++) {
        setTimeout(()=>{
          const ref = contentRef[i]['tabref'];
          ref.current.style.maxHeight = active == data[i].id ? ref.current.scrollHeight + 'px' : '0px';
        },500)
      }
    }
  };

  // General scroll to element function
  const scrollToTop = (index) => {
    setTimeout(() => {
      window.scroll({
        top: contentRef[index]['tabtitle'].current.getBoundingClientRect().top + window.pageYOffset - 90,
        behavior: 'smooth',
      });
    }, 500);
  };

  const handleOnClick = (id, index) => {
    if (active == id) {
      setActive(0);
      setHeight();
      return;
    }

    setActive(id);
    scrollToTop(index);
  };

  const renderTabs = () => {
    return data.map((item, index) => {
      const tabRef = useRef(null);
      const tabTitle = useRef(null);
      contentRef.push({ tabref: tabRef, tabtitle: tabTitle });
      return (
        <div
          key={index}
          id={'title-' + index}
          ref={tabTitle}
          className={`accordion-main ${active == item.id ? 'active' : ''}`}
        >
          <div className="accordion-head" onClick={() => handleOnClick(item.id, index)}>
            <h4>{item.title}</h4>
          </div>
          <div ref={tabRef} className="accordion-content">
            {active == item.id && item.source()}
          </div>
        </div>
      );
    });
  };

  return <div className="accordion-section">{renderTabs()}</div>;
};

export default Accordion;
